import * as React from 'react';
import { Spinner } from '@cian/ui-kit';

import * as styles from './PageLoader.css';

export const PageLoader: React.FC = () => {
  return (
    <div className={styles['overlay']}>
      <div className={styles['preloader']}>
        <Spinner size={50} />
      </div>
    </div>
  );
};
